module.exports = __webpack_public_path__ + "img/confirmation-tests.fc9d727d.svg";